import { TAP_LIMIT } from '../../../constants/AppConstants';
import Item, { SHIFT_UP_DESKTOP, SHIFT_UP_MOBILE } from './Item';
import { SIZE_GROUND } from './Item';

export default class Container extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isContainer = true;

    this.itemsContainer = this.game.make.group();
    this.itemsContainer.x = this.data.container.x;
    this.itemsContainer.y = this.data.container.y;
    this.front = this.game.make.image(0, 0, 'items', this.id + '_front');
    this.front.anchor.set(0.5, 1);

    this.addChild(this.itemsContainer);
    this.addChild(this.front);

    //
    this.items = [];
  }

  init(itemData) {
    // set open state
    this.isOpen = itemData.open;

    if (this.isOpen) {
      this.frameName = this.id + '_back';
    } else {
      this.itemsContainer.visible = false;
      this.front.visible = false;
    }

    // add initial items
    for (let i = 0; i < itemData.items.length; i++) {
      const item = this.location.addItem(itemData.items[i]);
      this.addItem(item, false);
    }
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.front.tint = this.tint;
  }

  lightUp() {
    super.lightUp();
    this.front.tint = this.tint;

    for (let i = 0; i < this.items.length; i++) {
      this.items[i].lightUp();
    }
  }

  darken() {
    super.darken();
    this.front.tint = this.tint;

    for (let i = 0; i < this.items.length; i++) {
      this.items[i].darken();
    }
  }

  addItem(item, save = true) {
    item.disable();
    this.itemsContainer.addChild(item);

    const w = this.data.container.width * 0.5;
    item.x = Phaser.Math.between(-w, w);
    item.y = 0;
    // set item scale
    if (item.data.container_scale) {
      console.log(item.id, item.data.container_scale);
      item.setScale(item.data.container_scale);
    } else {
      item.setScale(1);
    }

    item.container = this; // set reference to this stack
    this.items.push(item);

    this.updateBounds();

    this.animateSquize();

    this.game.sounds.playSFX('item_combine', { spriteID: 'sfx' });

    //
    save && this.onChange.dispatch();
  }

  emptyContainer() {
    if (this.items.length === 0) {
      return;
    }

    //
    const amount = Math.max(1, this.items.length - 1);
    const w = Math.min(150, amount * 30);
    const offset = w / amount;
    let x0 = this.x - w * 0.5;
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      item.enable();
      item.setScale(SIZE_GROUND);
      item.x = this.worldPosition.x - this.location.x;
      item.y = this.worldPosition.y;
      item.container = null;
      const dx = offset * i + Phaser.Math.between(-5, 5);
      const dy = Phaser.Math.between(5, 30);
      const x = x0 + dx;
      const y = this.y + dy;
      this.location.addObjectToLocation(item);
      if (this.location.tryPutIntoPond(item)) {
        x0 = item.x - w * 0.5;
        item.animateToPosition(x0 + dx, item.y, 500, true);
      } else {
        item.animateToPosition(x, y);
        this.location.setDestinationPosition(item);
      }
    }
    this.items = [];

    this.location.addCloud({ x: this.x, y: this.y - this.height * 0.3, h: this.bb.height });

    this.game.sounds.playSFX('item_combine', { spriteID: 'sfx' });
  }

  openContainer() {
    this.isOpen = true;
    this.frameName = this.id + '_back';
    this.front.visible = true;
    this.itemsContainer.visible = true;
  }

  canPutItem(item) {
    if (this.isOpen && !item.hasFlag('backpack_only')) {
      this.updateBounds();
      this.bb.x += -this.location.x;
      if (Phaser.Rectangle.contains(this.bb, item.x, item.y)) {
        this.bb.x += this.location.x;
        return true;
      }
      this.bb.x += this.location.x;
    }
    return false;
  }

  handleInputUp() {
    this.location.stopDragItem(this);
    this.drag = false;
    this.updateBounds();

    this.setScale(SIZE_GROUND);

    // check if it was moved
    const dx = this.pointer.x - this.startPos.x;
    const dy = this.pointer.y - this.startPos.y;
    const dist = dx * dx + dy * dy;

    this.pointer = null;

    if (dist < TAP_LIMIT && this.game.deviceMetric.platform.type !== 'desktop') {
      // fix position
      const dy =
        this.game.deviceMetric.platform.type === 'desktop' ? SHIFT_UP_DESKTOP : SHIFT_UP_MOBILE;
      this.y -= dy;

      this.handleTap();
    }
    // drop item
    this.onDrop.dispatch(this);
  }

  handleTap() {
    if (!this.isOpen) {
      this.openContainer();
    } else {
      this.animateStretch();
      this.game.time.events.add(150, this.emptyContainer, this);
    }
  }

  canHover() {
    return !this.drag && this.items.length > 0;
  }

  update() {
    this.itemsContainer.update();
    super.update();
  }

  //
  serialize() {
    const data = super.serialize();
    data.open = this.isOpen;
    data.items = [];
    for (let i = 0; i < this.items.length; i++) {
      data.items.push(this.items[i].id);
    }
    return data;
  }
}
